/* Scrapbook-Pages theme scripts */
(function () {
  'use strict';
  var SP = window.SP || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = SP.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    function withDelims(n, prec, th, dec) {
      th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2);
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.toggle('is-error', !!isError); t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 3000);
  }

  /* ---------- Image protection ---------- */
  if (document.body.classList.contains('protect-images')) {
    var block = function (e) { if (e.target instanceof HTMLImageElement) { e.preventDefault(); e.stopPropagation(); return false; } };
    document.addEventListener('contextmenu', block, true);
    document.addEventListener('dragstart', block, true);
  }

  /* ---------- Dropdown ---------- */
  document.addEventListener('click', function (e) {
    $$('details[data-dropdown][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('details[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
      closeCart();
    }
  });

  /* ---------- Share ---------- */
  function popup(url) { window.open(url, 'share', 'width=640,height=560,noopener,noreferrer'); }
  function copyLink() {
    var url = location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { toast(SP.copied || 'Link copied to clipboard'); }, function () { window.prompt('Copy this link:', url); });
    } else { window.prompt('Copy this link:', url); }
  }
  function nativeShare() { if (navigator.share) navigator.share({ title: document.title, url: location.href }).catch(function () {}); }
  var canShare = !!navigator.share;
  if (canShare) $$('[data-share="native"]').forEach(function (b) { b.hidden = false; });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]'); if (!b) return;
    var u = encodeURIComponent(location.href), t = encodeURIComponent(document.title);
    var rail = $('.share-rail'); var img = rail ? rail.getAttribute('data-share-image') : '';
    switch (b.getAttribute('data-share')) {
      case 'facebook': popup('https://www.facebook.com/sharer/sharer.php?u=' + u); break;
      case 'x': popup('https://twitter.com/intent/tweet?url=' + u + '&text=' + t); break;
      case 'pinterest': popup('https://pinterest.com/pin/create/button/?url=' + u + '&description=' + t + (img ? '&media=' + encodeURIComponent(img) : '')); break;
      case 'copy': copyLink(); break;
      case 'native': nativeShare(); break;
      case 'mobile': canShare ? nativeShare() : copyLink(); break;
    }
  });

  /* ---------- Cart ---------- */
  var drawer = $('#CartDrawer');
  var cartState = null;
  var variantLabel = '';
  try { variantLabel = JSON.parse(($('#CartStrings') || {}).textContent || '""'); } catch (e) {}
  try { cartState = JSON.parse(($('#CartInitial') || {}).textContent || 'null'); } catch (e) {}
  var icons = {};
  var iconTpl = $('#CartIcons');
  if (iconTpl) $$('[data-i]', iconTpl.content).forEach(function (el) { icons[el.getAttribute('data-i')] = el.innerHTML; });

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open');
    refreshCart();
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open');
  }
  function refreshCart() {
    return fetch((SP.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); return c; });
  }
  function updateBadge() {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cartState.item_count; el.hidden = cartState.item_count === 0; });
  }
  function renderCart() {
    if (!cartState) return;
    updateBadge();
    if (!drawer) return;
    var n = cartState.item_count;
    $('[data-cart-desc]', drawer).textContent = n === 0 ? ($('[data-cart-empty] p', drawer).textContent) : n + ' item' + (n !== 1 ? 's' : '');
    $('[data-cart-empty]', drawer).hidden = n !== 0;
    $('[data-cart-footer]', drawer).hidden = n === 0;
    var list = $('[data-cart-items]', drawer);
    list.innerHTML = cartState.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="d-line" data-line="' + (i + 1) + '">' +
        '<a class="d-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '">' : '') + '</a>' +
        '<div class="d-line__info"><div class="d-line__top"><a href="' + esc(it.url) + '" class="d-line__title">' + esc(it.product_title) + '</a>' +
        '<button type="button" class="d-line__remove" data-line-qty="0" aria-label="Remove">' + (icons.trash || '×') + '</button></div>' +
        (variantLabel ? '<p class="tiny muted">' + esc(variantLabel) + '</p>' : '') +
        '<div class="d-line__bottom"><div class="d-qty">' +
        '<button type="button" data-line-qty="' + (it.quantity - 1) + '" aria-label="Decrease">' + (icons.minus || '−') + '</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-line-qty="' + (it.quantity + 1) + '" aria-label="Increase">' + (icons.plus || '+') + '</button></div>' +
        '<p class="d-line__price">' + formatMoney(it.final_line_price) + '</p></div></div></div>';
    }).join('');
    $('[data-cart-total]', drawer).textContent = formatMoney(cartState.total_price);
    var min = parseInt(SP.cartMinimum, 10) || 0;
    var short = min > 0 && n > 0 && n < min;
    var minBox = $('[data-cart-min]', drawer);
    if (short) {
      var tpl = $('#CartMinTemplate');
      var html = (tpl ? tpl.innerHTML : '').replace(/\[min\]/g, min).replace(/\[count\]/g, n).replace(/\[needed\]/g, min - n);
      $('[data-cart-min-text]', drawer).innerHTML = html;
    }
    minBox.hidden = !short;
    $('[data-cart-checkout]', drawer).disabled = short;
  }
  function changeLine(line, qty, el) {
    if (el) el.closest('.d-line').classList.add('is-busy');
    return fetch((SP.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.items) { cartState = c; renderCart(); } else { toast((c && (c.description || c.message)) || 'Could not update cart', true); refreshCart(); }
    }).catch(function () { refreshCart(); });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-line-qty]');
    if (q) { var line = parseInt(q.closest('[data-line]').getAttribute('data-line'), 10); changeLine(line, parseInt(q.getAttribute('data-line-qty'), 10), q); }
  });
  var checkoutForm = $('[data-cart-checkout-form]');
  if (checkoutForm) checkoutForm.addEventListener('submit', function (e) {
    var min = parseInt(SP.cartMinimum, 10) || 0;
    if (cartState && min > 0 && cartState.item_count < min) e.preventDefault();
  });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshCart().catch(function () {}); });

  /* ---------- Product form ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var input = $('[data-qty-input]', form);
    var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    form.addEventListener('submit', function (e) {
      if (!drawer || !window.fetch) return;
      e.preventDefault();
      var btn = $('[data-add-btn]', form), label = $('[data-add-label]', form), spin = $('[data-add-spinner]', form), err = $('[data-add-error]', form);
      btn.disabled = true; label.hidden = true; spin.hidden = false; err.hidden = true;
      var fd = new FormData(form);
      fetch((SP.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { err.textContent = res.body.description || res.body.message || 'Could not add to cart'; err.hidden = false; return; }
          openCart();
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; label.hidden = false; spin.hidden = true; });
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('[data-main-media] img'); if (!main) return;
      main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset'); main.alt = t.getAttribute('data-alt');
      $$('[data-thumb]').forEach(function (o) { o.classList.toggle('is-active', o === t); o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
      var rail = $('.share-rail'); if (rail) rail.setAttribute('data-share-image', 'https:' + t.getAttribute('data-src').replace(/^https?:/, ''));
    });
  });

  /* ---------- Right panel: random product ---------- */
  $$('[data-rotate-one]').forEach(function (box) {
    var items = $$('.rail-feature__item', box); if (items.length < 2) return;
    var pick = Math.floor(Math.random() * items.length);
    items.forEach(function (it, i) { it.hidden = i !== pick; });
  });

  /* ---------- Reviews ---------- */
  var starSvg = ($('#StarTemplate') || { innerHTML: '' }).innerHTML;
  function stars(n, cls) {
    var out = '<span class="stars ' + (cls || '') + '" aria-label="' + n + ' of 5 stars">';
    for (var i = 1; i <= 5; i++) out += starSvg.replace('class="icon icon-star star', 'class="icon icon-star star' + (i <= n ? ' is-on' : ''));
    return out + '</span>';
  }
  function fmtDate(iso) { var p = String(iso || '').split('-'); return p.length === 3 ? p[1] + '/' + p[2] + '/' + p[0] : iso; }
  function loadReviews(scope) {
    var el = $('[data-reviews-json]', scope); if (!el) return [];
    try {
      var list = JSON.parse(el.textContent) || [];
      return list.filter(function (r) { return r && r.text; }).sort(function (a, b) { return String(b.date).localeCompare(String(a.date)); });
    } catch (e) { return []; }
  }
  $$('[data-rail-reviews]').forEach(function (box) {
    var reviews = loadReviews(box.parentNode);
    if (!reviews.length) { box.innerHTML = '<p class="rail-empty">No reviews yet.</p>'; return; }
    var idx = Math.floor(Math.random() * reviews.length);
    function show() {
      var r = reviews[idx % reviews.length];
      box.innerHTML = '<p class="rail-review__product">' + esc(r.product) + '</p>' + stars(r.rating) +
        '<p class="rail-review__text">"' + esc(r.text) + '"</p><p class="rail-review__by">— ' + esc(r.author) + ', ' + esc(fmtDate(r.date)) + '</p>';
    }
    show();
    setInterval(function () { idx = (idx + 1) % reviews.length; show(); }, parseInt(box.getAttribute('data-interval'), 10) || 8000);
  });
  $$('[data-reviews-page]').forEach(function (box) {
    var scope = box.parentNode;
    var reviews = loadReviews(scope);
    var per = parseInt(box.getAttribute('data-per-page'), 10) || 5;
    var dateTpl = box.getAttribute('data-date-label') || 'Date Added: [date] by [author]';
    var total = reviews.length, pages = Math.max(1, Math.ceil(total / per));
    var params = new URLSearchParams(location.search);
    var page = Math.min(Math.max(1, parseInt(params.get('p'), 10) || 1), pages);
    var nav = $('[data-reviews-pagination]', scope), count = $('[data-reviews-count]', scope);
    function render() {
      var slice = reviews.slice((page - 1) * per, page * per);
      count.textContent = 'Displaying ' + slice.length + ' of ' + total + ' reviews';
      box.innerHTML = slice.map(function (r) {
        return '<article class="panel review-card"><h2>' + esc(r.product) + '</h2>' + stars(r.rating, 'stars--md') +
          '<p class="review-card__text">' + esc(r.text) + '</p><p class="review-card__meta">' +
          esc(dateTpl.replace('[date]', fmtDate(r.date)).replace('[author]', r.author)) + '</p></article>';
      }).join('');
      if (nav) {
        nav.hidden = pages <= 1;
        $('[data-rev-status]', nav).textContent = 'Page ' + page + ' of ' + pages;
        $('[data-rev-prev]', nav).disabled = page <= 1;
        $('[data-rev-next]', nav).disabled = page >= pages;
      }
    }
    function go(p) {
      page = p; render();
      var u = new URL(location.href); if (p > 1) u.searchParams.set('p', p); else u.searchParams.delete('p');
      history.replaceState(null, '', u.toString()); window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (nav) {
      $('[data-rev-prev]', nav).addEventListener('click', function () { if (page > 1) go(page - 1); });
      $('[data-rev-next]', nav).addEventListener('click', function () { if (page < pages) go(page + 1); });
    }
    render();
  });

  /* ---------- Star picker ---------- */
  $$('[data-star-picker]').forEach(function (picker) {
    var opts = $$('.star-picker__opt', picker);
    function paint(n) { opts.forEach(function (o, i) { o.classList.toggle('is-on', i < n); }); }
    var current = 0;
    opts.forEach(function (o, i) {
      var inp = $('input', o);
      o.addEventListener('mouseenter', function () { paint(i + 1); });
      o.addEventListener('mouseleave', function () { paint(current); });
      inp.addEventListener('change', function () { current = i + 1; paint(current); });
    });
  });

  /* ---------- Background music (Pawprints) ---------- */
  var audio = $('[data-bg-music]'), mbtn = $('[data-music-toggle]');
  if (audio && mbtn) {
    var on = $('[data-music-on]', mbtn), off = $('[data-music-off]', mbtn);
    var blocked = false;
    audio.volume = parseFloat(audio.getAttribute('data-volume')) || 0.35;
    function setUi() {
      var isOff = audio.muted || blocked || audio.paused;
      on.hidden = isOff; off.hidden = !isOff;
      mbtn.setAttribute('aria-pressed', String(!isOff));
      mbtn.setAttribute('aria-label', isOff ? 'Turn music on' : 'Mute music');
    }
    var p = audio.play(); if (p && p.catch) p.catch(function () { blocked = true; setUi(); });
    audio.addEventListener('play', setUi); audio.addEventListener('pause', setUi);
    mbtn.addEventListener('click', function () {
      if (blocked || audio.paused) {
        audio.muted = false; blocked = false;
        var pp = audio.play(); if (pp && pp.catch) pp.catch(function () { blocked = true; setUi(); });
      } else { audio.muted = !audio.muted; }
      setUi();
    });
    setUi();
  }

  /* initial badge */
  if (cartState) updateBadge();
})();
